import React from 'react';
import './UiWidgetSeparator.scss';
import type { WidgetCommonProps } from '../hooks/integrations/externalIntegrationTypes';

const UiWidgetSeparator: React.FC<WidgetCommonProps> = ({ row }) => {
	return <div className="UiWidgetSeparator" />;
};

export default UiWidgetSeparator;
